"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  prHolidays: {
    index: 'index',
    holid: 'holid',
    holname: 'holname',
    holyear: 'holyear',
    typename: 'typename',
    startfrom: 'startfrom',
    endwith: 'endwith',
    holidayRange: 'holiday Range',
    salaryAdjustment: 'salary Adjustment',
    remark: 'remark',
    add: 'add',
    del: 'del',
    edit: 'edit',
    print: 'print',
    table: 'table',
    stamp: 'stamp',
    systemMaintenance: 'system Maintenance',
    basicData: 'basic Data',
    holidayMaintenance: 'holiday Maintenance',
    submitted: 'submitted',
    unSubmitted: 'un Submitted',
    hint: 'hint',
    confirm: 'confirm',
    cancel: 'cancel',
    delSuc: 'del Suc',
    delFail: 'del Fail',
    delCancel: 'del Cancel',
    selectOneData: 'select One Data',
    payableDaysMaintenanceData: 'payable Days Maintenance Data',
    save: 'save',
    submit: 'submit',
    yes: 'yes',
    no: 'no',
    cmt: 'cmt',
    goBack: 'goBack',
    basicInfo: 'basic Info',
    operateInfo: 'operate Info',
    createInfo: 'create Info',
    modifyInfo: 'modify Info',
    submitInfo: 'submit Info',
    message1: 'Please select the row to delete',
    message2: 'This operation will permanently delete the piece of data',
    message3: 'Your changes may not be saved',
    message4: 'Please fill in holiday name',
    message5: 'Salary adjustment cannot exceed 9 digits',
    message6: 'The number of days for payroll cannot be greater than 3 digits',
    message7: 'Successfully saved',
    message8: 'Failed to save',
    message9: 'abnormal',
    message10: 'close the window',
    message12: 'Please fill in the year',
    message14: 'Please fill in holiday category',
    message15: 'Submitted data cannot be deleted',
    message16: 'Increase in proportion to original salary (%)',
    message17: 'Salary increase (yuan)',
    message18: 'Start date cannot be later than end date'
  }
};